import axios from "axios";
import router from "@/router";
import { clearPortalAuthInShell } from "@/microfrontends/portalAuthSync";
import { SMApp, SMNotifications, SMTasks, SMUser } from "@/store";
import { AUTH_STAY_SIGNED_IN_KEY, AUTH_TOKEN_KEY } from "@/utils/authStorage";
import { HttpStatusCodes } from "@/constants/httpStatusCodes";
import { RAuth } from "@/pages/Auth/RAuth";
import VueRouter from "vue-router";
import { RErrors } from "@/pages/Errors/RErrors";

const LOGIN_ROUTE = "Login";
const MAINTENANCE_MODE_ERROR_ROUTE = "Error503";
//
// const convertUrlSpecCharsToUnicode = (url) => {
//   return encodeURI(url).replaceAll("+", "%2B");
// };

// const ENCODING_AMPERSAND = "%26";
// const ENCODED_STRING_WITH_AMPERSAND = "%20%26%20";

axios.defaults.paramsSerializer = (params: URLSearchParams) => {
  return Object.entries(params)
    .map((x) => {
      const key = encodeURIComponent(x[0]);
      const value = encodeURIComponent(x[1]);

      return `${key}=${value.replace("%2526", "%26")}`;
    })
    .join("&");
};

// Add a request interceptor
axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // Object.assign(config, {
    //   url: convertUrlSpecCharsToUnicode(config?.url),
    // });
    //
    // config.url = convertUrlSpecCharsToUnicode(config?.url);

    // Append "company_id" to each "Expert" request;
    if (SMUser.isExpert) {
      const hasParams = Object.prototype.hasOwnProperty.call(config, "params");

      if (!hasParams) {
        Object.assign(config, {
          params: {},
        });
      }

      // Check if "Company_id" not set. To avoid rewrite params;
      if (!Object.prototype.hasOwnProperty.call(config.params, "company_id")) {
        let { company_id } = router?.currentRoute?.params;

        if (!company_id && SMTasks.companyId) company_id = String(SMTasks.companyId);

        if (company_id) {
          Object.assign(config.params, { company_id });
        }
      }

      // Check if "case_id" not set. To avoid rewrite params;
      if (!Object.prototype.hasOwnProperty.call(config.params, "case_id")) {
        const { case_id } = router?.currentRoute?.params;

        if (case_id) Object.assign(config.params, { case_id });
      }
    }

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    /**
     * If response is successfully, then we should switch off "Maintenance mode" in app,
     * because it is mean that this mode is switched off on server, or user IP in "white-list".
     */
    if (response.status === 200) {
      if (window.localStorage.getItem("maintenance-mode")) {
        window.localStorage.removeItem("maintenance-mode");
      }
    }

    return response;
  },
  async function(error) {
    console.log(error);

    const { path } = (router as VueRouter | any).history.current;

    // Detect if it is "Error" path.
    const pathMatchErrorRoutes =
      RErrors.path === path ||
      (RErrors.children?.length &&
        RErrors.children.some((x) => `${RErrors.path}/${x.path}` === path || x.path === path));

    // Detect if it is "Auth" path.
    const pathMatchAuthRoutes =
      RAuth.path === path ||
      (RAuth.children?.length &&
        RAuth.children.some((x) => `${RAuth.path}/${x.path}` === path || x.path === path));

    if (error.response?.status === HttpStatusCodes.UNAUTHORIZED) {
      window.localStorage.removeItem(AUTH_TOKEN_KEY);
      window.localStorage.removeItem(AUTH_STAY_SIGNED_IN_KEY);

      SMUser.unsetUser();
      SMNotifications.stopNotificationsRefresh();
      SMApp.resetAuthOnServer();
      clearPortalAuthInShell();

      if (!pathMatchAuthRoutes) {
        await router.push({ name: LOGIN_ROUTE });
      }
    }

    /**
     * Catch error when "Maintenance mode" is switch on.
     */
    if (error.response?.status === HttpStatusCodes.SERVICE_UNAVAILABLE) {
      window.localStorage.setItem("maintenance-mode", "true");

      SMUser.unsetUser();

      SMNotifications.stopNotificationsRefresh();

      if (!pathMatchErrorRoutes) await router.push({ name: MAINTENANCE_MODE_ERROR_ROUTE });
    }

    return Promise.reject(error);
  }
);

export default axios;
